import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=1921fe47&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"
import style0 from "./Tour.vue?vue&type=style&index=0&id=1921fe47&prod&lang=less"
import style1 from "./Tour.vue?vue&type=style&index=1&id=1921fe47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921fe47",
  null
  
)

export default component.exports